/**
 * @desc getModeBySupplierIdNamesAndSettlementMethodType
 */
const URL = "/rantion-srm";
import http, { updateResponse } from "@/http";
export function request(body: defs.srm.CheckWhetherExistsSettlementDto, options?: any) {
  return updateResponse(
    http(URL + `/srm/getModeBySupplierIdNamesAndSettlementMethodType`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
